import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/talent',
    authDomain: 'authenticate.seek.com',
    clientDomain: 'id.employer.seek.com',
    clientId: 'sYNUTz7AyCjaFmy0DqzdSarWCIoh3R28',
    environment: 'prod',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    contactUs: {
        en: 'https://jobstreet-about.kinsta.seekasia.com/about-us/contact-us-indonesia/',
        id: 'https://www.jobstreet.com/about-us/id-id/hubungi-kami-di-indonesia/',
    },
    siteName: siteNames.employer.seek.id,
    zone: getZoneFromSite(siteNames.employer.seek.id),
    brand: Brand.SEEK,
    product: Product.HIRER,
};
//# sourceMappingURL=id_employer_seek_com.js.map